import { HTTPInstanceWithPrefix } from '@/lib/http/http-instance-with-prefix'
import { GOOGLE_LOCATION_ENDPOINT } from '../config'
import {
  AutocompleteRequest,
  AutocompleteResponse,
  GetLocationResponse,
  GoogleLocation,
  PlaceSuggestion,
  SaveRequest,
  SaveResponse,
  SelectRequest,
  SelectResponse
} from './GoogleLocationAPI.model'

/**
 * REST client for the venue's Google place. Endpoints are prefixed with
 * `/restaurants/{restaurantId}` by HTTPInstanceWithPrefix; the contract is
 * spelled out in `config.ts`.
 */
class GoogleLocationAPI {
  static autocomplete = (
    request: AutocompleteRequest,
    signal: AbortSignal
  ): Promise<PlaceSuggestion[]> =>
    HTTPInstanceWithPrefix.post<AutocompleteResponse>(
      `${GOOGLE_LOCATION_ENDPOINT}/autocomplete`,
      request,
      { signal }
    ).then(res => res.data.suggestions ?? [])

  static select = (request: SelectRequest): Promise<SelectResponse> =>
    HTTPInstanceWithPrefix.post<SelectResponse>(
      `${GOOGLE_LOCATION_ENDPOINT}/select`,
      request
    ).then(res => res.data)

  static save = (request: SaveRequest): Promise<GoogleLocation> =>
    HTTPInstanceWithPrefix.put<SaveResponse>(
      GOOGLE_LOCATION_ENDPOINT,
      request
    ).then(res => res.data.location)

  static getLocation = (): Promise<GoogleLocation | null> =>
    HTTPInstanceWithPrefix.get<GetLocationResponse>(
      GOOGLE_LOCATION_ENDPOINT
    ).then(res => res.data.location ?? null)

  static disconnect = (): Promise<void> =>
    HTTPInstanceWithPrefix.delete(GOOGLE_LOCATION_ENDPOINT).then(
      () => undefined
    )
}

export default GoogleLocationAPI
